import { useState } from 'react';

import { Icon } from 'components';
import { PAGE_CONTAINER_ID } from 'constants/layout';
import { routes } from 'constants/routing';
import { Link } from 'containers/Link';
import { useTranslation } from 'libs/translations';
import { cn } from 'utilities';

import ClaimRewardButton from 'containers/Layout/ClaimRewardButton';
import { ConnectButton } from 'containers/Layout/ConnectButton';
import useGetMenuItems from 'containers/Layout/useGetMenuItems';
import { useIsOnMarketPage } from '../../useIsOnMarketPage';
import { ChainSelect } from '../ChainSelect';
import { NavLink } from './NavLink';
import DarkModeButton from 'components/DarkModeButton';

export const XsControls: React.FC = () => {
  const { t } = useTranslation();
  const [isMobileMenuOpened, setIsMobileMenuOpened] = useState<boolean>(false);
  const menuItems = useGetMenuItems();

  const isOnMarketPage = useIsOnMarketPage();

  const toggleMobileMenu = () => {
    // Toggle scroll on page container and body tags
    const pageContainerDom = document.getElementById(PAGE_CONTAINER_ID);
    pageContainerDom?.classList.toggle('overflow-hidden');
    document.body.classList.toggle('overflow-hidden');

    setIsMobileMenuOpened(currentIsMobileMenuOpened => !currentIsMobileMenuOpened);
  };

  return (
    <div className={cn('md:hidden', isMobileMenuOpened && 'bg-background')}>
      <div className="flex h-14 items-center pr-4 md:h-auto relative">
        <Link
          className="mr-5 flex h-full flex-none items-center justify-center pl-4"
          to={routes.dashboard.path}
        >
          <Icon name='enclabs' className="w-7"/>
        </Link>

        <div className="flex flex-1 items-center justify-center">
           
          <ChainSelect
            className="mr-4"
            buttonClassName="h-9"
            variant={isOnMarketPage && !isMobileMenuOpened ? 'tertiary' : 'primary'}
          />

          <ConnectButton
            className="h-9 max-w-xs flex-1 px-1"
            variant={isOnMarketPage && !isMobileMenuOpened ? 'secondary' : 'primary'}
          />
        </div>

        <button
          onClick={toggleMobileMenu}
          type="button"
          className={cn(
            'bg-primary hover:bg-mediumBlue active:bg-mediumBlue ml-5 flex h-9 w-9 flex-none items-center justify-center rounded-lg p-0',
          )}
        >
          <Icon
            name={isMobileMenuOpened ? 'closeRounded' : 'burger'}
            className={cn('text-white h-auto', isMobileMenuOpened ? 'w-[14px]' : 'w-[18px]')}
          />
        </button>
      </div>

      <div
        className={cn(
          'bg-background fixed bottom-0 left-0 right-0 top-14 z-50 overflow-y-auto pb-8 pt-4',
          isMobileMenuOpened ? 'block' : 'hidden',
        )}
      >
        <div className="mb-6">
          {menuItems.map(menuItem => (
            <NavLink onClick={toggleMobileMenu} key={menuItem.i18nKey} {...menuItem} />
          ))}

          <div className='flex justify-center mt-8'>
            <DarkModeButton/>
          </div>
        </div>

        <div className="px-4">
          {/*<ClaimRewardButton
            className="w-full"
            variant={isOnMarketPage && !isMobileMenuOpened ? 'secondary' : 'primary'}
          />*/}
        </div>
      </div>
    </div>
  );
};
